import ApiClient from "./repository";
import authstore from '@/store/modules/auth';

export default {
    async getCategories(id) {
        var client = await ApiClient.getClient();
        const params = new URLSearchParams();
        params.append("categoryGroupId", id);
        const { data } = await client.get("Category/GetCategories", {
            params: params
        });
        return {
            list: data.data,
            totalItems: data.count
        };
    },
    async getCategoryGroups() {
        console.log("getcatgr")
        let jwt = authstore.getters.jwtDecoded(authstore.state);
        console.log("jwt",jwt);
        console.log("nameee", jwt.city_code);

        var client = await ApiClient.getClient();
        const params = new URLSearchParams();
        params.append("cityCode", jwt.city_code);
        const { data } = await client.get("/Category/GetCategoryGroups", {
            params: params
        });
        return {
            list: data.data,
            totalItems: data.count
        };
    },
    async addCategoryGroup(category) {
        var client = await ApiClient.getClient();
        const params = new URLSearchParams();
        params.append("cityCode", "55");
        params.append("name", category.name);
        console.log("name", category.name)
        console.log("params", params)
        console.log("name", category.name)
        let cat = JSON.stringify({
            cityCode: "55",
            name: category.name
        });
        const { data } = await client.post("Category/AddCategoryGroup", {
            body: {
                cityCode: 55,
                name: category.name
            }
        });
        return {
            list: data.data,
            totalItems: data.count
        };
    }
};